import React, { Fragment } from "react";

const AdditionalUserMessage = props => {
  const userLimit = "five";
  const { renewal } = props;
  if (props.packages.length > 0) {
    const showAdditionalUserMessage = !props.packages.every(
      item => !item.additionalusersallowed
    );
    if (showAdditionalUserMessage || props.paperPackage) {
      return (
        <div className={
          renewal
            ? "order-drawer-renew__addusers-msg"
            : "order-drawer__addusers-msg"
        }>
        {(showAdditionalUserMessage ?
        <>
          <p>
            Your order includes <strong>unlimited teacher logins</strong>.
          </p>
          <p>
            <strong>*</strong>Each product is limited to {userLimit}{" "}
            simultaneous sessions. If you require wider use, please extend your
            subscription at just £10 per additional simultaneous user.{" "}
            {props.basketOpen ? (
              ""
            ) : (
              <Fragment>
                <span className="basket-link" onClick={props.handleShowBasket}>
                  Edit in basket
                </span>{" "}
                to do so.
              </Fragment>
            )}
          </p>
        </>
          : "")}
          {(props.paperPackage ?
          <>
            <p>Please note: a Complete Primary Package subscription is required to order printed tests. Please ensure you have renewed your current subscription before purchase.</p>
          </>
          :
          "")}
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default AdditionalUserMessage;
